import { render } from "./tertiary-chart.vue?vue&type=template&id=668973c7"
import script from "./tertiary-chart.vue?vue&type=script&lang=js"
export * from "./tertiary-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__